<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
    
      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          ADMIN GAS
        </h1>
       
      </v-flex>
      <v-flex xs12>
        <v-img
          :src="require('../assets/logo.jpg')"
          class="my-3"
          contain
          height="300"
        ></v-img>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {


  data() {
    return {
      date: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
    };
  },

  data: () => ({
    created() {
    this.inicio();
  },
  }),

  methods: {
    inicio(){
      alert('entrol');
      this.$swal(date);
    }
  }
};
</script>
